"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorIcon = void 0;
const React = __importStar(require("react"));
function ErrorIcon(props) {
    return (React.createElement("svg", Object.assign({ width: "22", height: "22", viewBox: "0 0 23 23", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M16.9803 18.7397L4.37303 6.13234C1.703 9.65916 1.97612 14.7041 5.19237 17.9203C8.40863 21.1366 13.4535 21.4097 16.9803 18.7397ZM18.4327 17.3636C21.4258 13.8275 21.255 8.52708 17.9203 5.19239C14.5856 1.8577 9.28514 1.68689 5.74907 4.67996L18.4327 17.3636ZM19.3345 3.77818C23.6303 8.07394 23.6303 15.0388 19.3345 19.3345C15.0387 23.6303 8.07393 23.6303 3.77816 19.3345C-0.517606 15.0388 -0.517606 8.07394 3.77816 3.77818C8.07393 -0.517591 15.0387 -0.517591 19.3345 3.77818Z", fill: "currentColor" })));
}
exports.ErrorIcon = ErrorIcon;
